import { useTranslation } from 'react-i18next'

const Schoolyard = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="schoolyard-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="schoolyard-title">{t('antagonists:classmate1:components:background')}</title>
      <defs>
        <clipPath id="schoolyard-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="schoolyard-c">
          <path
            style={{
              fill: '#4f91b2',
            }}
            d="m1163.04 435.44-.75 461.58 184.21-5.17-.76-455.42-182.7-.99z"
          />
        </clipPath>
        <clipPath id="schoolyard-d">
          <path
            style={{
              fill: '#4f91b2',
            }}
            d="m1377.12 435.67 3.81 454.53 182.86.26-4.54-457.85-182.13 3.06z"
          />
        </clipPath>
        <style>
          {
            '.f,.g,.h,.i{fill:none}.j{fill:#eeeef0}.k{fill:#e8d180}.l{fill:#f3d484}.m{fill:#30513f}.n{fill:#ddc07a}.o{fill:#cbced4}.p{fill:#235a96}.q{fill:#a3853f}.r{fill:#6195b3}.s{fill:#4f91b2}.t{fill:#74a2be}.g{stroke-width:9.95px}.g,.h,.i{stroke:#e64427}.g,.i{stroke-miterlimit:10}.h{stroke-linejoin:round;stroke-width:2.15px}.h,.i{stroke-linecap:round}.u{clip-path:url(#schoolyard-c)}.v{clip-path:url(#schoolyard-b)}.w{clip-path:url(#schoolyard-d)}.i{stroke-width:11.45px}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#schoolyard-b)',
        }}
        id="schoolyard-a"
      >
        <path
          style={{
            fill: '#f3d484',
          }}
          d="M-116.96-17.89h2108.82v1080.55H-116.96z"
        />
        <path
          style={{
            fill: '#e8d180',
          }}
          d="m-272.06 863.37 2370.9-3.41-21.23 417.93-2321.04-1.2-28.63-413.32z"
        />
        <path
          style={{
            fill: '#a3853f',
          }}
          d="m1130.58 910.46-2.91-675.31 461.41-.68 4.13 686.53-462.63-10.54z"
        />
        <path
          style={{
            fill: '#74a2be',
          }}
          d="m1163.72 296.28 2.65 110.06 388.7-1.34V295.09l-391.35 1.19z"
        />
        <path
          style={{
            fill: '#4f91b2',
          }}
          d="m1163.04 435.44-.75 461.58 184.21-5.17-.76-455.42-182.7-.99z"
        />
        <g
          style={{
            clipPath: 'url(#schoolyard-c)',
          }}
        >
          <path
            style={{
              fill: '#cbced4',
            }}
            d="m1159.33 734.13-4.51 221.75 203.98-1.59 4.11-221.87-203.58 1.71z"
          />
        </g>
        <path
          style={{
            fill: '#4f91b2',
          }}
          d="m1377.12 435.67 3.81 454.53 182.86.26-4.54-457.85-182.13 3.06z"
        />
        <g
          style={{
            clipPath: 'url(#schoolyard-d)',
          }}
        >
          <path
            style={{
              fill: '#cbced4',
            }}
            d="m1374.51 732.38 1.3 216.08 204.85-1.91 4.11-214.63-210.26.46z"
          />
        </g>
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#ddc07a',
          }}
          d="m-265.2 890.77 2370.91-3.41-21.23 417.93-2321.04-1.21-28.64-413.31z"
        />
        <path
          d="M1401.11 619.02c.56 19.27-15.11 36.98-36.64 36.98s-38.2-16.5-37.58-36.83c.59-19.25 13.96-35.42 37.75-35.05 22.57.35 35.94 17.02 36.46 34.9Zm-36.62-25.89c-17.83-.28-27.85 11.84-28.29 26.27-.47 15.24 12.03 27.61 28.16 27.61 16.14 0 27.88-13.28 27.46-27.72-.39-13.4-10.41-25.89-27.33-26.16Z"
          style={{
            fill: '#30513f',
          }}
        />
        <path
          d="M1372.48 64.55c-49.2-.76-76.83 32.67-78.06 72.47-1.3 42.04 33.18 76.16 77.7 76.16s76.92-36.63 75.76-76.47c-1.08-36.97-28.72-71.44-75.39-72.16Z"
          style={{
            fill: '#eeeef0',
          }}
        />
        <path
          style={{
            fill: '#30513f',
          }}
          d="m1369.58 149.11 2.34-52.13 3.81-.51 1.22 52.37-7.37.27z"
        />
        <path
          style={{
            fill: '#30513f',
          }}
          d="m1341.24 156.04 41.17-16.48-2.18-7.3-40.73 20.34 1.74 3.44zM1394.96 88.21v2.03l2.49-.22.14 10.97 2.67.21-.18-14.3-5.12 1.31zM1334.78 88.42v2.03l2.48-.23.15 10.98 2.67.21-.18-14.3-5.12 1.31zM1341.41 87.59v2.03l2.49-.23.14 10.98 2.67.21-.18-14.3-5.12 1.31zM1364.42 81.16v2.03l2.48-.22.15 10.97 2.39-.34-.18-14.3-4.84 1.86zM1372.52 80.83s3.87-3.01 6.42-.82c2.09 1.79 1.87 3.98-.03 6.52-1.91 2.55-4 4.53-4 4.53l4.41-.15.26 2.12-7.44.23.02-2.51s1.66-2.02 3.59-4.33c1.49-1.79 2.42-2.91 1.57-4.18-.9-1.34-3.64.36-3.64.36l-1.14-1.78ZM1412.93 105.23s3.91-3.97 7.29-1.68c2.8 1.89 2.18 4.7.05 7.55a70.165 70.165 0 0 1-3.97 4.86h4.84l-.15 2.51-8.29.17-.18-2.6s2.23-2.83 4.49-5.33c1.96-2.17 3.11-3.34 2.09-4.63-1.32-1.68-5.04.99-5.04.99l-1.12-1.82ZM1419.84 131.35s6.82-1.7 7.36 3.63c.38 3.75-3.44 4.4-3.44 4.4s4.17.66 4.1 4.01c-.1 5.39-7.73 4.62-7.73 4.62l-.12-2.2s5.31-.11 5.13-2.53c-.18-2.42-4.29-1.81-4.29-1.81l-.42-3.24s4.41-.11 4.41-2.97-4.65-2.09-4.65-2.09l-.36-1.81ZM1410.79 160.31l-1.62 9.25 6.11-.18.45 4.94 2.02.13-.36-14.45-2.2-.22v7.36l-3.31.02.66-7.05-1.75.2zM1399.24 178.02h-5.94l-.16 6.77s5.07-.37 5.12 2.25c.06 3-5 2.62-5 2.62l.04 2.23s7.01.64 7.17-4.62c.14-4.62-5.1-4.78-5.1-4.78l.1-2.08 3.71-.16.06-2.22ZM1372.57 184.55s-6.83 4.87-6.83 8.88 1.71 5.27 5.04 5.08c2.76-.16 4.15-3.73 3.18-5.8-1.37-2.95-5.11-2.07-5.11-2.07l4.98-5.39-1.24-.69ZM1314.75 149.68s6.74-5.84 6.46-10.31c-.28-4.47-2.36-5.57-5.44-5.38-3.08.2-4.36 4.45-3.13 6.69 1.74 3.19 5.85 1.95 5.85 1.95l-5.16 6.36 1.43.68ZM1341.06 177.64l9.33.42-2.49 14.92h-2.28l1.45-12.23-6.01-.83v-2.28zM1325.65 159.86c-3.13.23-4.08 1.74-4.19 4.12-.14 3.07 3.15 3.57 3.15 3.57s-3.57 1.2-3.36 4.1c.21 2.9 1.84 4.26 4.54 4.26s5.37-1.14 4.89-4.61c-.49-3.49-3.57-3.75-3.57-3.75s3.43-.39 3.23-3.5c-.21-3.11-1.88-4.4-4.68-4.19ZM1314.62 111.35v2.04l1.81-.04.15 10.98 2.3-.16.18-13.93-4.44 1.11zM1324.07 110.44c-2.68.18-4.23 3.55-4.03 6.63.19 3.07.77 6.92 4.9 7.01 4.13.1 4.71-4.42 4.42-7.3-.29-2.88-1.06-6.63-5.28-6.34Z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m328.97 161.87 1.32 392.56 252.52 1.81-.71-392.83-253.13-1.54z"
        />
        <path
          style={{
            fill: '#6195b3',
          }}
          d="m346.02 180.85 1.67 338.35 218.97 1.67-1.12-338.63-219.52-1.39z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m454.13 178.71-4.74 350.47 12.99.46 4-351.07-12.25.14z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m334.52 267.7 234.38 1.69.17-12.98-234.77-.96.22 12.25zM338.86 356.55l234.37 1.7.18-12.99-234.78-.96.23 12.25zM336.69 447.58l234.38 1.69.17-12.99-234.77-.96.22 12.26zM641.12 163.97l1.32 392.55 252.52 1.82-.71-392.83-253.13-1.54z"
        />
        <path
          style={{
            fill: '#6195b3',
          }}
          d="m658.18 182.95 1.67 338.35 218.96 1.67-1.12-338.63-219.51-1.39z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m766.28 180.81-4.74 350.47 12.99.46 4-351.07-12.25.14z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m646.67 269.8 234.38 1.69.17-12.99-234.77-.96.22 12.26zM651.01 358.65l234.38 1.7.17-12.99-234.78-.96.23 12.25zM648.84 449.67l234.38 1.7.17-12.99-234.77-.96.22 12.25z"
        />
        <path
          style={{
            fill: '#30513f',
          }}
          d="m265.74 439.47 3.07 541.01 13.04-.22.03-539.8-16.14-.99z"
        />
        <path
          d="M162.68 445.14c-.16-23.87-.69-116.75.43-137.03.44-7.88 11.29-22.7 34.07-36.61 23.8-14.53 52.42-22.86 78.51-22.86.95 0 1.9.01 2.85.03 64.2 1.44 105.53 42.89 106.63 64.97 1.12 22.43-.38 109.98-.8 133.09l-221.7-1.61Z"
          style={{
            fill: '#eeeef0',
          }}
        />
        <path
          d="M275.7 254.33c.91 0 1.82.01 2.73.03 27.33.61 53.62 9.05 74.03 23.75 18.1 13.04 26.63 27.39 27.05 35.83 1.04 20.73-.19 97.94-.71 127.08l-210.47-1.53c-.19-30.21-.58-112.28.46-131.07.31-5.56 10.24-19.18 31.35-32.07 22.94-14 50.47-22.03 75.55-22.03m0-11.37c-60.88 0-116.97 41.56-118.26 64.83-1.31 23.65-.4 142.99-.4 142.99l232.92 1.69s2.22-112.83.9-139.1c-1.31-26.28-45.99-68.89-112.18-70.37-.99-.02-1.99-.03-2.98-.03Z"
          style={{
            fill: '#235a96',
          }}
        />
        <path
          style={{
            fill: 'none',
            stroke: '#e64427',
            strokeMiterlimit: 10,
            strokeWidth: '9.95px',
          }}
          d="m229.99 325.38 1.31 67.42 89.48-1.95-.29-67.73-90.5 2.26z"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#e64427',
            strokeLinecap: 'round',
            strokeMiterlimit: 10,
            strokeWidth: '11.45px',
          }}
          d="m347.08 417.55-148.38-.49"
        />
        <path
          d="M234.58 502.43c.49 14.79-8.76 32.97-2.79 36.95 8.87 5.92 16.21-18.31 16.21-18.31s-4.93 20.21 2.96 20.7c8.87.55 10.35-21.2 10.35-21.2s-3.54 22.68 8.38 22.68c8.38 0 7.39-21.2 7.39-21.2s-.99 22.68 9.86 21.2c8.53-1.16 5.42-22.18 5.42-22.18s9.37 22.18 18.24 17.75c8.87-4.44-7.89-21.2-6.9-34.51.99-13.31 40.42-82.81 40.42-82.81l-143.45.99s33.5 67.96 33.9 79.95Z"
          style={{
            fill: 'none',
            stroke: '#e64427',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2.15px',
          }}
        />
        <path
          style={{
            fill: 'none',
            stroke: '#e64427',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2.15px',
          }}
          d="m248 521.07 22.94-98.49 21.42 98.49-69.03-98.49 53.75 99.48 45.35-100.07-61.12 98.59-60.64-98.1L248 521.07z"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#e64427',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '2.15px',
          }}
          d="m253.91 421.99-19.73 72.91 66.64-72.12 2.85 80.9"
        />
      </g>
    </svg>
  )
}

export default Schoolyard
